import { User } from '../admin/admin.types';
import { TaskScope, TaskStatus } from './task.enums';

export type Task = {
  admin: User | null;
  adminId: number;
  adminIds: number[];
  admins: User[] | null;
  assigned: boolean;
  candidate: any;
  candidateId: number | null;
  completed: boolean;
  completedAt: string | null;
  createdAt: string;
  description: string | null;
  dueDate: string | null;
  id: number;
  timezone: string;
  title: string;
  triggered: boolean;
  updatedAt: string;
};

export enum TaskSortType {
  DueDate = 'dueDate',
  CreatedAt = 'createdAt',
}

export type TaskRequestParams = {
  status: TaskStatus;
  scope: TaskScope;
  adminIds: number[];
  sortBy: TaskSortType;
  limit: number;
  page: number;
};

export type TaskCollection = {
  tasks: Task[];
  counters: { completed: number; uncompleted: number };
};
